import React, { useEffect, useRef, useState } from "react";
import add from "../../images/add.svg";
import { Box, Button, Dialog, DialogContent } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import Search from "../components/Search";
import { BodyContainer } from "../styles";
import { ButtonAdd, customStyles, Header, TopGrid } from "../styles";
import DataTable from "react-data-table-component";
import Loader from "../components/Loader";
import { Link } from "react-router-dom";
import Repo from "../../Repository/Repo";
import billImg from "../../images/bill.png";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { UserDetailsPrint } from "./Print";
const styles = `
@media all {
  .pagebreak {
    display: none;
  }
}
@media print {
  .pagebreak {
    page-break-before: always;
  }
}
`;

function UserDetails() {
  const componentRef = useRef();
  const [records, setRecords] = useState([]);
  const [state, setState] = useState({
    searchText: "",
    loading: false,
    selected: "",
    modal: false,
  });

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      name: "Sr #",
      width: "90px",
      selector: (row) => row?.srNum,
    },
    {
      name: "Print",
      selector: (row) => (
        <img
          height="50px"
          src={billImg}
          alt=""
          onClick={() => handlePrint(row)}
        />
      ),
    },
    {
      name: "Name",
      selector: (row) => row?.cName,
    },
    {
      name: "Date",
      selector: (row) => row?.date,
    },
    {
      name: "Vehicle Number",
      selector: (row) => row?.vChesis,
    },
  ];

  const handlePrint = (selected) => {
    setState((p) => ({ ...p, modal: true, selected }));
    print();
  };

  const getData = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await Repo.vehicle({
      request: {
        method: "getVRegistartionsByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setRecords(data.response.data.registrationsArr);
    setState((prev) => ({ ...prev, loading: false }));
  };
  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const searchedItems = () => {
    if (state.searchText != "") {
      const filtered = records.filter((item) =>
        item?.cName.toLowerCase().includes(state.searchText)
      );
      return filtered;
    } else {
      return records;
    }
  };
  const toggle = () => {
    setState((prev) => ({ ...prev, modal: !prev.modal }));
  };
  const print = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "30px" } }}>
        <TopGrid container alignItems="center">
          <Grid item md={3} xs={12}>
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={state.searchText}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={7.5} md={5} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              User Vehicle Form
            </Typography>
          </Grid>
          <Grid align="center" item lg={1.5} md={4} xs={12}>
            <Link to="/inventory/admin/add-user-details">
              <ButtonAdd
                variant="contained"
                sx={{ width: { md: "100%", xs: "90%" } }}
              >
                Add <img src={add} alt="add" />
              </ButtonAdd>
            </Link>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer
        sx={{ position: "relative", top: { md: "0px", xs: "40px" } }}
      >
        <DataTable
          columns={columns}
          data={searchedItems()}
          highlightOnHover={true}
          customStyles={customStyles}
          pointerOnHover={true}
        />
        <Loader loading={state.loading} />
      </BodyContainer>

      <Dialog
        title="Add"
        open={state.modal}
        onClose={toggle}
        fullWidth
        maxWidth="md"
        sx={{ minHeight: "500px" }}
      >
        <DialogContent dividers={scroll === "paper"}>
          <>
            <Button
              onClick={toggle}
              variant="contained"
              sx={{
                borderRadius: "5px",
                textTransform: "none",
                cursor: "pointer",
                mr: 2,
              }}
            >
              Go Back
            </Button>
            <ReactToPrint
              pageStyle={styles}
              trigger={() => (
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: "5px",
                    textTransform: "none",
                    cursor: "pointer",
                    mr: 2,
                  }}
                >
                  Print Reciept
                </Button>
              )}
              onBeforePrint={toggle}
              content={() => componentRef.current}
            />
            <UserDetailsPrint detail={state.selected} ref={componentRef} />
          </>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default UserDetails;
